export default function(selector, message, level, timeOut) {
  selector.innerHTML = `<p class='alert ${level}'>${message}</p>`
  setTimeout(() => { selector.children[0].remove() }, timeOut)
}
